import { render, staticRenderFns } from "./IrArriba.vue?vue&type=template&id=a19423a4&scoped=true&"
import script from "./IrArriba.vue?vue&type=script&lang=js&"
export * from "./IrArriba.vue?vue&type=script&lang=js&"
import style0 from "./IrArriba.vue?vue&type=style&index=0&id=a19423a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19423a4",
  null
  
)

export default component.exports